import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext(null);

function AuthContextProvider({children}) {

  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      axios.get("/api/user/login/check")
      .then(res => {
        if (res.data) {
          const userData = {
            userId: res.data.userId,
            userName: res.data.userName
          }

          setUser(userData);
        } else {
          setUser(null);
        }
      })
      .catch(err => {
        setUser(null);
      })
      .finally(() => {
        setLoading(false);
      });
    };

    initAuth();
  }, [navigate]);

  return (
    <AuthContext.Provider
      children={children}
      value={{
        user,
        setUser,
        loading,
        setLoading
      }}
    />
  );
}

export { AuthContext, AuthContextProvider };